export default __webpack_public_path__ + "static/media/Neutrif-Studio-Bold.58a9f973.ttf";